import { connect } from 'react-redux'
import { chatbotSelectors, getStep, PortfolioWizardStepNames } from 'modules/ui/ChatBot'
import { ChatBot } from '../../components'

const mapStateToProps = (state, { push }: any) => ({
  actions: [],
  step: getStep(PortfolioWizardStepNames.type),
  displayStep: chatbotSelectors.getCurrentPortfolioStatus(state) === 'in progress',
  title: 'Lease type',
  description:
    'Select the type of lease you want to create. This determines how billing and communication are managed.',
  displayDescription: chatbotSelectors.getCurrentPortfolioStatus(state) === 'in progress',
})

const mapDisptchToProps = (dispatch: any) => ({
  actionClickHandler: (action: any) => dispatch(action()),
})

export default connect(mapStateToProps, mapDisptchToProps)(ChatBot)
